import { useTranslation } from 'react-i18next'
// simple wrapper to drop reaplace localisation

export const useT = (namespaces?: string | string[]) => {
  const props = useTranslation(namespaces)
  return props
}